import { isValidEmail } from "./utils";

const BaseInput = class extends HTMLElement {
  value = ""
  input = document.createElement("input");
  errorLabel = document.createElement("span");
  isValid = true
  min = 0
  max = Number.MAX_SAFE_INTEGER;

  constructor() {
    super();
    this.handleKey = this.handleKey.bind(this);
    this.labelState = this.labelState.bind(this);
  }

  connectedCallback() {
    this.value = this.getAttribute("value") || "";
    this.input.type = this.getAttribute("type") || "text";
    this.input.name = this.getAttribute("name") || "";
    this.input.value = this.value || "";
    this.input.id = this.getAttribute("id") + "-input" || "";
    this.input.setAttribute("aria-labelledby", this.id + "-input");
    this.input.className = "input";

    this.min = parseInt(this.getAttribute("min") || "0");
    this.max = parseInt(this.getAttribute("max") || Number.MAX_SAFE_INTEGER.toString());
    if (this.hasAttribute("required")) this.input.required = true;
    
    this.errorLabel.classList.add("form__message");

    this.innerHTML = this.renderContainer(this.getAttribute("label") || "");
    this.querySelector(".form__block-inner")?.prepend(this.input);

    this.input.addEventListener("keyup", this.handleKey);
    this.input.addEventListener("blur", this.labelState);
    this.input.addEventListener("focus", this.labelState);
    this.classList.add("loaded");

    this.labelState();
  }

  handleKey(e: KeyboardEvent) {
    this.value = (e.target as HTMLInputElement).value;
    this.validateInput();
    this.labelState();
  }

  validateInput() {
    this.errorLabel.innerHTML = "";
    // required rules
    if (this.input.required && this.value.length <= 0) {
      return this.invalidate(`This field is required`);
    }
    // min rules
    if (this.min && this.value.length < this.min) {
      return this.invalidate(`Field must be at least ${this.min} characters`);
    }
    // max rules
    if (this.min && this.value.length < this.min) {
      return this.invalidate(`Field must be at least ${this.min} characters`);
    }
    // email rules
    if (this.input.type === "email" && !isValidEmail(this.value)) {
      return this.invalidate(`Email address is not valid`);
    }
    this.isValid = true;
    this.applyValidStyle();
  }

  invalidate(message: string) {
    this.isValid = false;
    this.errorLabel.innerHTML = message;
    this.applyValidStyle();
  }

  applyValidStyle() {
    const label = this.querySelector("label");
    if (this.isValid) {
      this.input.classList.remove("input--error");
      label?.classList.remove("label--error");
      this.removeChild(this.errorLabel);
    } else {
      this.input.classList.add("input--error");
      label?.classList.add("label--error");
      this.appendChild(this.errorLabel);
    }
  }

  labelState() {
    this.input.classList.add(this.value.length ? "has-value" : "is-empty");
    this.input.classList.remove(this.value.length ? "is-empty" : "has-value");
  }

  renderContainer(label:string) {
    return /* html */`
      <div class="form__block">
        <div class="form__block-inner">
          <label id="customer-email-label" for="${this.input.id}" class="label label--input">
            ${label}
            ${this.input.required ? `<span class="form__required">*</span>` : ""}
          </label>
        </div>
      </div>
    `
  }
};

customElements.define("base-input", BaseInput);